import * as Preact from 'preact';
import ButtonUnstyled from '@mui/base/ButtonUnstyled';
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import Typography from '@mui/material/Typography';

import { styled } from '@mui/system';

export const RETURN_TO_STORE_HEIGHT = '44px';

export interface Props {
    onReturnToStoreClick: () => void;
    returnToStoreText: string;
}

const ButtonRoot = styled('button')(() => ({
    boxSizing: 'border-box',
    border: 'none',
    boxShadow: 'none',
    height: RETURN_TO_STORE_HEIGHT,
    padding: '12px',
    width: '100%',
    display: 'flex',
    gap: '11px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.8)',
}));

export const Component = (p: Props) => {
    return (
        <ButtonUnstyled component={ButtonRoot} onClick={p.onReturnToStoreClick} disableTouchRipple>
            <Typography variant="body2" sx={{ color: '#ffffff' }}>
                {p.returnToStoreText}
            </Typography>
            <KeyboardArrowDown fontSize="small" sx={{ color: '#ffffff' }}/>
        </ButtonUnstyled>
    );
};

Component.displayName = 'ReturnToStoreBanner';
